export interface ManufacturerOption {
  id: string;
  name: string;
  count: number; // number of collections for this manufacturer
}

/**
 * Professional manufacturer selector — a row of card-style options (name + collection count) with a
 * clear selected state. Shared by the initial "Choose a manufacturer" card and the DoorPicker's
 * Manufacturer accordion section, so the two read identically. Manufacturers carry no logo in the
 * catalogue, so the card leads with the name and a "N styles" subline.
 */
export function ManufacturerSelect({ options, selectedId, onSelect, testId }: {
  options: ManufacturerOption[];
  selectedId: string;
  onSelect: (id: string) => void;
  testId?: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Manufacturer"
      data-testid={testId}
      style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: 8 }}
    >
      {options.map((o) => {
        const sel = o.id === selectedId;
        return (
          <button
            key={o.id || "other"}
            type="button"
            className="rg-tile"
            role="radio"
            aria-checked={sel}
            onClick={() => onSelect(o.id)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 2,
              padding: "10px 14px",
              cursor: "pointer",
              textAlign: "left",
              borderRadius: "var(--radius-sm)",
              border: `1.5px solid ${sel ? "var(--brand)" : "var(--border)"}`,
              background: sel ? "var(--brand-tint)" : "var(--surface)",
              boxShadow: sel ? "0 0 0 3px var(--ring)" : "none",
            }}
          >
            <span style={{ fontSize: 14, fontWeight: 600, color: sel ? "var(--brand-active)" : "var(--text)", lineHeight: 1.2 }}>
              {o.name}
            </span>
            <span style={{ fontSize: 11, color: "var(--muted)" }}>
              {o.count} {o.count === 1 ? "style" : "styles"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
